<template>
    <nly-content-wrapper>
        <nly-breadcrumb>
            <nly-breadcrumb-item text="home" />
            <nly-breadcrumb-item text="breadcrumb"  />
            <nly-breadcrumb-item text="alunos"  active />
        </nly-breadcrumb>
        <nly-content>
            <nly-row>
                <nly-col>
                    <nly-card>
                        <nly-card-header>
                           Titulo do item
                        </nly-card-header>
                        <nly-card-body>
                        
                        </nly-card-body>
                    </nly-card>
                </nly-col>
            </nly-row>
        </nly-content>
    </nly-content-wrapper>
</template>

<script>
export default {
    data () {
        return {
            itemTo: [
                {
                    text: "home",
                    to: "/"
                },
                {
                    text: "collapse",
                    to: "/collapse"
                },
                {
                    text: "breadcrumb",
                    to: "/breadcrumb",
                    active: true
                }
            ],
            itemHref: [
                {
                    text: "home",
                    href: "/"
                },
                {
                    text: "collapse",
                    href: "/collapse"
                },
                {
                    text: "breadcrumb",
                    href: "/breadcrumb",
                    active: true
                }
            ],
            itemIcon: [
                {
                    text: "home",
                    to: "/",
                    icon: "nlyfont nly-icon-home-fill",
                    linkClass: "text-danger"
                },
                {
                    text: "collapse",
                    to: "/collapse",
                    icon: "nlyfont nly-icon-outlet"
                },
                {
                    text: "breadcrumb",
                    to: "/breadcrumb",
                    active: true,
                    icon: "nlyfont nly-icon-security-fill"
                }
            ],
            itemIconOnly: [
                {
                    text: "home",
                    to: "/",
                    icon: "nlyfont nly-icon-home-fill"
                },
                {
                    text: "collapse",
                    to: "/collapse"
                },
                {
                    text: "breadcrumb",
                    to: "/breadcrumb",
                    active: true
                }
            ]
        };
    }
};
</script>
